import { render } from "./PartsMaster.vue?vue&type=template&id=4d68fada&scoped=true&lang=true"
import script from "./PartsMaster.vue?vue&type=script&lang=js"
export * from "./PartsMaster.vue?vue&type=script&lang=js"

import "./PartsMaster.vue?vue&type=style&index=0&id=4d68fada&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d68fada"]])

export default __exports__